import { Injectable, NgModule, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { HttpClient, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Injectable()

@NgModule({
  imports: [MatDialogModule, BrowserAnimationsModule, FormsModule]
})

export class CommissionService {
  myAppUrl: string = "";

  constructor(private _http: Http, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  //** Commission
  getCommissions(month, year, monthFlgId) {
    return this._http.get(this.myAppUrl + 'api/commission/GetListCommissions/' + month + '/' + year + '/' + monthFlgId, {
      headers: new Headers({
        "Authorization": "Bearer " + localStorage.getItem("jwt"),
        "Content-Type": "application/json; charset=utf-8"
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}  



// WEBPACK FOOTER //
// ./src/app/services/commission-service.ts